import { useLazyQuery } from '@apollo/client'
import { GET_LOG_FILE } from './operations'
import { GetLogFile, GetLogFileVariables } from '../../types'

export const useGetLogFile = ({ onCompleted }: { onCompleted: (data: GetLogFile) => void }) =>
  useLazyQuery<GetLogFile, GetLogFileVariables>(GET_LOG_FILE, {
    onCompleted,
  })
